import urls from '@/legacy/config/env';
import api from '@/legacy/services/api';

import type { ApiPermissionsResponse } from '../types';

export const fetchPermissions = async (): Promise<ApiPermissionsResponse> => {
	const response = await api.get<ApiPermissionsResponse>(urls.auth.loginPermissions);
	return response.data;
};
